var _templateObject, _templateObject2, _templateObject3, _templateObject4;
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _regeneratorRuntime() {
  "use strict";

  var r = _regenerator(),
    e = r.m(_regeneratorRuntime),
    t = (Object.getPrototypeOf ? Object.getPrototypeOf(e) : e.__proto__).constructor;
  function n(r) {
    var e = "function" == typeof r && r.constructor;
    return !!e && (e === t || "GeneratorFunction" === (e.displayName || e.name));
  }
  var o = {
    throw: 1,
    return: 2,
    break: 3,
    continue: 3
  };
  function a(r) {
    var e, t;
    return function (n) {
      e || (e = {
        stop: function stop() {
          return t(n.a, 2);
        },
        catch: function _catch() {
          return n.v;
        },
        abrupt: function abrupt(r, e) {
          return t(n.a, o[r], e);
        },
        delegateYield: function delegateYield(r, o, a) {
          return e.resultName = o, t(n.d, _regeneratorValues(r), a);
        },
        finish: function finish(r) {
          return t(n.f, r);
        }
      }, t = function t(r, _t, o) {
        n.p = e.prev, n.n = e.next;
        try {
          return r(_t, o);
        } finally {
          e.next = n.n;
        }
      }), e.resultName && (e[e.resultName] = n.v, e.resultName = void 0), e.sent = n.v, e.next = n.n;
      try {
        return r.call(this, e);
      } finally {
        n.p = e.prev, n.n = e.next;
      }
    };
  }
  return (_regeneratorRuntime = function _regeneratorRuntime() {
    return {
      wrap: function wrap(e, t, n, o) {
        return r.w(a(e), t, n, o && o.reverse());
      },
      isGeneratorFunction: n,
      mark: r.m,
      awrap: function awrap(r, e) {
        return new _OverloadYield(r, e);
      },
      AsyncIterator: _regeneratorAsyncIterator,
      async: function async(r, e, t, o, u) {
        return (n(e) ? _regeneratorAsyncGen : _regeneratorAsync)(a(r), e, t, o, u);
      },
      keys: _regeneratorKeys,
      values: _regeneratorValues
    };
  })();
}
function _regeneratorValues(e) {
  if (null != e) {
    var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"],
      r = 0;
    if (t) return t.call(e);
    if ("function" == typeof e.next) return e;
    if (!isNaN(e.length)) return {
      next: function next() {
        return e && r >= e.length && (e = void 0), {
          value: e && e[r++],
          done: !e
        };
      }
    };
  }
  throw new TypeError(_typeof(e) + " is not iterable");
}
function _regeneratorKeys(e) {
  var n = Object(e),
    r = [];
  for (var t in n) r.unshift(t);
  return function e() {
    for (; r.length;) if ((t = r.pop()) in n) return e.value = t, e.done = !1, e;
    return e.done = !0, e;
  };
}
function _regeneratorAsync(n, e, r, t, o) {
  var a = _regeneratorAsyncGen(n, e, r, t, o);
  return a.next().then(function (n) {
    return n.done ? n.value : a.next();
  });
}
function _regeneratorAsyncGen(r, e, t, o, n) {
  return new _regeneratorAsyncIterator(_regenerator().w(r, e, t, o), n || Promise);
}
function _regeneratorAsyncIterator(t, e) {
  function n(r, o, i, f) {
    try {
      var c = t[r](o),
        u = c.value;
      return u instanceof _OverloadYield ? e.resolve(u.v).then(function (t) {
        n("next", t, i, f);
      }, function (t) {
        n("throw", t, i, f);
      }) : e.resolve(u).then(function (t) {
        c.value = t, i(c);
      }, function (t) {
        return n("throw", t, i, f);
      });
    } catch (t) {
      f(t);
    }
  }
  var r;
  this.next || (_regeneratorDefine2(_regeneratorAsyncIterator.prototype), _regeneratorDefine2(_regeneratorAsyncIterator.prototype, "function" == typeof Symbol && Symbol.asyncIterator || "@asyncIterator", function () {
    return this;
  })), _regeneratorDefine2(this, "_invoke", function (t, o, i) {
    function f() {
      return new e(function (e, r) {
        n(t, i, e, r);
      });
    }
    return r = r ? r.then(f, f) : f();
  }, !0);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };
      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2(e, r, n, t);
}
function _OverloadYield(e, d) {
  this.v = e, this.k = d;
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _taggedTemplateLiteral(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
    raw: {
      value: Object.freeze(t)
    }
  }));
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _superPropGet(t, o, e, r) {
  var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e);
  return 2 & r && "function" == typeof p ? function (t) {
    return p.apply(e, t);
  } : p;
}
function _get() {
  return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
    var p = _superPropBase(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
    }
  }, _get.apply(null, arguments);
}
function _superPropBase(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t)););
  return t;
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
import "../../../icon-button/gator/icon-button.gator.js";
import "../../../date-picker/base/gator/datepicker.gator.js";
import { customElement as g } from "../../../../node_modules/.pnpm/@lit_reactive-element@2.1.1/node_modules/@lit/reactive-element/decorators/custom-element.js";
import { property as h } from "../../../../node_modules/.pnpm/@lit_reactive-element@2.1.1/node_modules/@lit/reactive-element/decorators/property.js";
import { state as d } from "../../../../node_modules/.pnpm/@lit_reactive-element@2.1.1/node_modules/@lit/reactive-element/decorators/state.js";
import { NgcInputText as v } from "../input-text/input-text.gator.js";
import "../../../../node_modules/.pnpm/@lit_reactive-element@2.1.1/node_modules/@lit/reactive-element/reactive-element.js";
import { html as m } from "../../../../node_modules/.pnpm/lit-html@3.3.1/node_modules/lit-html/lit-html.js";
import "../../../../node_modules/.pnpm/lit-element@4.2.1/node_modules/lit-element/lit-element.js";
import { createRef as c, ref as D } from "../../../../node_modules/.pnpm/lit-html@3.3.1/node_modules/lit-html/directives/ref.js";
import { autoUpdate as _, computePosition as I } from "../../../../node_modules/.pnpm/@floating-ui_dom@1.7.4/node_modules/@floating-ui/dom/dist/floating-ui.dom.js";
import k from "../../../../packages/web-components/src/components/input/gator/input-date/input-date.gator.scss.js";
import { NgcErrorEvent as y, NgcErrorReason as b } from "../../../../utils/error-utils.js";
import { msg as E } from "../../../../node_modules/.pnpm/@lit_localize@0.12.2/node_modules/@lit/localize/init/install.js";
import { localized as R } from "../../../../node_modules/.pnpm/@lit_localize@0.12.2/node_modules/@lit/localize/internal/localized-decorator.js";
import "../../../../node_modules/.pnpm/@lit_localize@0.12.2/node_modules/@lit/localize/init/runtime.js";
import { ifDefined as f } from "../../../../node_modules/.pnpm/lit-html@3.3.1/node_modules/lit-html/directives/if-defined.js";
import { unsafeCSS as x } from "../../../../node_modules/.pnpm/@lit_reactive-element@2.1.1/node_modules/@lit/reactive-element/css-tag.js";
var S = Object.defineProperty,
  $ = Object.getOwnPropertyDescriptor,
  V = Object.getPrototypeOf,
  T = Reflect.get,
  r = function r(t, e, a, i) {
    for (var n = i > 1 ? void 0 : i ? $(e, a) : e, o = t.length - 1, l; o >= 0; o--) (l = t[o]) && (n = (i ? l(e, a, n) : l(n)) || n);
    return i && n && S(e, a, n), n;
  },
  L = function L(t, e, a) {
    return T(V(t), a, e);
  },
  N = function (t) {
    return t.INVALID_FORMAT = "invalid-format", t.LESS_THAN_MIN_DATE = "less-than-min-date", t.GREATER_THAN_MAX_DATE = "greater-than-max-date", t.OUTSIDE_RANGE = "outside-range", t.INVALID_START_DATE = "invalid-start-date", t.INVALID_END_DATE = "invalid-end-date", t;
  }(N || {});
var s = /*#__PURE__*/function (_v) {
  function s() {
    var _this;
    _classCallCheck(this, s);
    _this = _callSuper(this, s, arguments), _this.locale = navigator.language, _this.sundayStart = !1, _this.range = !1, _this.startDateLabel = "Start Date", _this.endDateLabel = "End Date", _this.maskInput = !1, _this._value = "", _this.datepickerRef = c(), _this.datepickerTriggerRef = c(), _this.startInputRef = c(), _this.endInputRef = c(), _this.groupRef = c(), _this.dateValue = null, _this._dateSeparator = "/", _this._messageInvalidFormat = "Invalid date. Please provide a valid date with format {0}.", _this._messageLessThanMinDate = "Date must be after {0}.", _this._messageGreaterThanMaxDate = "Date must be before {0}.", _this._messageOutsideRange = "Date must be between {0} and {1}.", _this._messageInvalidStartDate = "{0} must come before {1}: {2}.", _this._messageInvalidEndDate = "{0} must come after {1}: {2}.", _this._datePickerVisible = !1, _this._startDate = null, _this._endDate = null, _this._maskPattern = "", _this._dateString = "";
    return _this;
  }
  _inherits(s, _v);
  return _createClass(s, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      _superPropGet(s, "connectedCallback", this, 3)([]), this.endIcon = "calendar";
    }
  }, {
    key: "updated",
    value: function updated(t) {
      if (_superPropGet(s, "updated", this, 3)([t]), t.has("locale") && ((this.locale === void 0 || this.locale === "") && (this.locale = navigator.language), this.setLocaleDateFormat(), this._value = this.value ? this.value.toLocaleDateString(this.locale) : ""), t.has("value")) if (this.value && this.value instanceof Date && !isNaN(this.value.getTime())) {
        this.dateValue = this.value;
        var e = this.value.toLocaleDateString(this.locale);
        this._dateString = e, this.maskInput && this.maskDate(e), this.maskInput ? this._value = this._maskPattern : this._value = e;
      } else this._dateString = "", this._maskPattern = "", this.dateValue = null, this._value = "";
      if (t.has("dateValue")) if (this.dateValue && this.dateValue instanceof Date && !isNaN(this.dateValue.getTime())) {
        var _e = this.dateValue.toLocaleDateString(this.locale);
        this._dateString = _e, this.maskInput && this.maskDate(_e);
      } else this.dateValue === null && (this._dateString = "", this._maskPattern = "");
      if (t.has("startDate") && (this.startDate && this.startDate instanceof Date && !isNaN(this.startDate.getTime()) ? (this._startDate = this.startDate, this._startDateInputValue = this.startDate.toLocaleDateString(this.locale)) : (this._startDate = null, this._startDateInputValue = "")), t.has("endDate") && (this.endDate && this.endDate instanceof Date && !isNaN(this.endDate.getTime()) ? (this._endDate = this.endDate, this._endDateInputValue = this.endDate.toLocaleDateString(this.locale)) : (this._endDate = null, this._endDateInputValue = "")), t.has("maskInput") && this.value && this.value instanceof Date && !isNaN(this.value.getTime())) {
        var _e2 = this.value.toLocaleDateString(this.locale);
        this._dateString = _e2, this.maskInput ? (this.maskDate(_e2), this._value = this._maskPattern) : this._value = _e2;
      }
    }
  }, {
    key: "render",
    value: function render() {
      return m(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n            ", "\n            ", "\n        "])), this.range ? this.rangeMarkup : _superPropGet(s, "render", this, 3)([]), this.datepickerMarkup);
    }
  }, {
    key: "endIconMarkup",
    get: function get() {
      return this.calendarIconMarkup;
    }
  }, {
    key: "calendarIconMarkup",
    get: function get() {
      return m(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n            <ngc-icon-button\n                slot=\"end-slot\"\n                ", "\n                ?disabled=", "\n                size=\"medium\"\n                icon-name=\"calendar\"\n                .ariaLabel=\"", "\"\n                @click=", "\n            ></ngc-icon-button>\n        "])), D(this.datepickerTriggerRef), this.disabled || this.readonly, E("Open date picker"), this.toggleVisibility);
    }
  }, {
    key: "datepickerMarkup",
    get: function get() {
      var _this2 = this;
      return m(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n            <ngc-datepicker\n                ", "\n                class=\"datepicker ", "\"\n                locale=", "\n                .min=", "\n                .max=", "\n                .selectedDate=", "\n                ?range=", "\n                ?sunday-start=", "\n                .startDate=", "\n                .endDate=", "\n                @dateChange=", "\n                @rangeChange=", "\n                @focusout=", "\n                @done=", "\n                @keydown=", "\n            ></ngc-datepicker>\n        "])), D(this.datepickerRef), this._datePickerVisible ? "datepicker-visible" : "", this.locale, this.minDate, this.maxDate, this.datepickerSelectedDate, this.range, this.sundayStart, this.datepickerStartDate, this.datepickerEndDate, this.handleDatepickerChange, this.handleDatepickerRangeChange, this.handleDatepickerFocusOut, this.closeDatepicker, function (t) {
        t.key === "Escape" && _this2.closeDatepicker();
      });
    }
  }, {
    key: "handleDatepickerFocusOut",
    value: function handleDatepickerFocusOut(t) {
      t.relatedTarget !== this.datepickerTriggerRef.value && (this._datePickerVisible = !1);
    }
  }, {
    key: "closeDatepicker",
    value: function closeDatepicker() {
      var _this$datepickerRef$v, _this$startInputRef$v, _this$inputRef$value;
      (_this$datepickerRef$v = this.datepickerRef.value) !== null && _this$datepickerRef$v !== void 0 && _this$datepickerRef$v.handleClose(), this._datePickerVisible = !1, this.range ? (_this$startInputRef$v = this.startInputRef.value) === null || _this$startInputRef$v === void 0 ? void 0 : _this$startInputRef$v.focus() : (_this$inputRef$value = this.inputRef.value) === null || _this$inputRef$value === void 0 ? void 0 : _this$inputRef$value.focus();
    }
  }, {
    key: "datepickerSelectedDate",
    get: function get() {
      return this.dateValue instanceof Date && !isNaN(this.dateValue.getTime()) ? this.dateValue : null;
    }
  }, {
    key: "handleChange",
    value: function handleChange(t) {
      var _this3 = this;
      t.preventDefault(), t.stopPropagation();
      var e = t.target;
      this._value = e.value, this.validateDate(function (a, i) {
        return _this3.setDateValue(a, i);
      }, e.value), this.dispatchEvent(new CustomEvent("change", this.dateEventData));
    }
  }, {
    key: "handleInputEvent",
    value: function handleInputEvent(t) {
      var _this4 = this;
      t.preventDefault(), t.stopPropagation();
      var e = t.target;
      this._value = e.value, this.validateDate(function (a, i) {
        return _this4.setDateValue(a, i);
      }, e.value), this.dispatchEvent(new CustomEvent("input", this.dateEventData));
    }
  }, {
    key: "handleInputFocusIn",
    value: function handleInputFocusIn() {
      _superPropGet(s, "handleInputFocusIn", this, 3)([]), this.maskInput && !this._internalValidationError && this._maskPattern && (this._value = this._dateString);
    }
  }, {
    key: "handleInputFocusOut",
    value: function handleInputFocusOut() {
      _superPropGet(s, "handleInputFocusOut", this, 3)([]), this.maskInput && !this._internalValidationError && this._maskPattern && (this._value = this._maskPattern);
    }
  }, {
    key: "setDateValue",
    value: function setDateValue(t, e) {
      e ? this._internalValidationError = e : this._internalValidationError = "", this.dateValue = t;
    }
  }, {
    key: "handleDatepickerChange",
    value: function handleDatepickerChange(t) {
      t.detail.date ? this._value = new Intl.DateTimeFormat(this.locale).format(t.detail.date) : this._value = "", this.dateValue = t.detail.date, this._internalValidationError = "", this.dispatchEvent(new CustomEvent("change", this.dateEventData));
    }
  }, {
    key: "dateEventData",
    get: function get() {
      return {
        bubbles: !0,
        composed: !0,
        detail: {
          value: this._value,
          valueAsDate: this.dateValue
        }
      };
    }
  }, {
    key: "rangeMarkup",
    get: function get() {
      var _this5 = this;
      return requestAnimationFrame(function () {
        var _this5$shadowRoot, _this5$shadowRoot2;
        var t = (_this5$shadowRoot = _this5.shadowRoot) === null || _this5$shadowRoot === void 0 ? void 0 : _this5$shadowRoot.querySelector("ngc-input-label"),
          e = (_this5$shadowRoot2 = _this5.shadowRoot) === null || _this5$shadowRoot2 === void 0 ? void 0 : _this5$shadowRoot2.querySelectorAll("ngc-help-text");
        t && _this5.groupRef.value && (_this5.groupRef.value.ariaLabelledByElements = [t]), e && _this5.groupRef.value && (_this5.groupRef.value.ariaDescribedByElements = Array.from(e));
      }), m(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n            <div ", " role=\"group\">\n                ", "\n                <div class=\"gator-input-date-range\">\n                    <ngc-input-text\n                        ", "\n                        label=", "\n                        .value=", "\n                        placeholder=", "\n                        error-text=", "\n                        ?disabled=", "\n                        ?required=", "\n                        ?readonly=", "\n                        @input=", "\n                        @change=", "\n                    >\n                        ", "\n                    </ngc-input-text>\n                    <ngc-input-text\n                        ", "\n                        label=", "\n                        .value=\"", "\"\n                        placeholder=", "\n                        error-text=", "\n                        ?disabled=", "\n                        ?required=", "\n                        ?readonly=", "\n                        @input=", "\n                        @change=", "\n                    >\n                        ", "\n                    </ngc-input-text>\n                </div>\n                ", "\n            </div>\n        "])), D(this.groupRef), this.labelMarkup, D(this.startInputRef), this.startDateLabel, this._startDateInputValue || "", f(this._placeholder), f(this.errorText || void 0), this.disabled, this.required, this.readonly, function (t) {
        return _this5.handleRangeInputEvent(t, function (e, a) {
          return _this5.setStartDate(e, t.detail.value, a);
        });
      }, function (t) {
        return _this5.handleRangeChangeEvent(t, function (e, a) {
          return _this5.setStartDate(e, t.detail.value, a);
        });
      }, this.calendarIconMarkup, D(this.endInputRef), this.endDateLabel, this._endDateInputValue || "", f(this._placeholder), f(this.errorText || void 0), this.disabled, this.required, this.readonly, function (t) {
        return _this5.handleRangeInputEvent(t, function (e, a) {
          return _this5.setEndDate(e, t.detail.value, a);
        });
      }, function (t) {
        return _this5.handleRangeChangeEvent(t, function (e, a) {
          return _this5.setEndDate(e, t.detail.value, a);
        });
      }, this.calendarIconMarkup, this.bottomText);
    }
  }, {
    key: "setStartDate",
    value: function setStartDate(t, e, a) {
      this.errorText || (a ? this.startInputRef.value.errorText = a : this.startInputRef.value.errorText = ""), this._startDate = t, this._startDateInputValue = e;
    }
  }, {
    key: "setEndDate",
    value: function setEndDate(t, e, a) {
      this.errorText || (a ? this.endInputRef.value.errorText = a : this.endInputRef.value.errorText = ""), this._endDate = t, this._endDateInputValue = e;
    }
  }, {
    key: "datepickerStartDate",
    get: function get() {
      if (this._startDate instanceof Date && !isNaN(this._startDate.getTime())) return this._startDate;
    }
  }, {
    key: "datepickerEndDate",
    get: function get() {
      if (this._endDate instanceof Date && !isNaN(this._endDate.getTime())) return this._endDate;
    }
  }, {
    key: "handleRangeInputEvent",
    value: function handleRangeInputEvent(t, e) {
      t.preventDefault(), t.stopPropagation();
      var a = t.detail.value;
      this.validateDate(e, a), this.dispatchEvent(new CustomEvent("input", this.rangeEventData));
    }
  }, {
    key: "handleRangeChangeEvent",
    value: function handleRangeChangeEvent(t, e) {
      t.preventDefault(), t.stopPropagation();
      var a = t.detail.value;
      this.validateDate(e, a), this.dispatchEvent(new CustomEvent("change", this.rangeEventData));
    }
  }, {
    key: "rangeEventData",
    get: function get() {
      return {
        bubbles: !0,
        composed: !0,
        detail: {
          startDate: this._startDate,
          endDate: this._endDate,
          value: this.dateRangeTextValue
        }
      };
    }
  }, {
    key: "dateRangeTextValue",
    get: function get() {
      var t = this._startDate instanceof Date ? this._startDate.toLocaleDateString(this.locale) : "",
        e = this._endDate instanceof Date ? this._endDate.toLocaleDateString(this.locale) : "";
      return "".concat(t, " - ").concat(e);
    }
  }, {
    key: "handleDatepickerRangeChange",
    value: function handleDatepickerRangeChange(t) {
      !t.detail.startDate && !t.detail.endDate && this.closeDatepicker(), t.detail.startDate !== this._startDate && (this._startDate = t.detail.startDate, this._startDateInputValue = t.detail.startDate ? new Intl.DateTimeFormat(this.locale).format(t.detail.startDate) : ""), t.detail.endDate !== this.endDate && (this._endDate = t.detail.endDate, this._endDateInputValue = t.detail.endDate ? new Intl.DateTimeFormat(this.locale).format(t.detail.endDate) : ""), this.errorText || (this.endInputRef.value.errorText = "", this.startInputRef.value.errorText = ""), this.dispatchEvent(new CustomEvent("change", this.rangeEventData));
    }
  }, {
    key: "validateDate",
    value: function validateDate(t, e) {
      var a = this.getDateValueFromLocalizedDateString(e),
        i = null;
      typeof a == "number" && isNaN(a) && (i = this.handleError("invalid-format")), a && _typeof(a) == "object" && (this.minDate && a < this.minDate && (i = this.handleError("less-than-min-date")), this.maxDate && a > this.maxDate && (i = this.handleError("greater-than-max-date")), this.minDate && this.maxDate && (a < this.minDate || a > this.maxDate) && (i = this.handleError("outside-range")), this.range && (this._startDate && a < this._startDate && (i = this.handleError("invalid-end-date")), this._endDate && a > this._endDate && (i = this.handleError("invalid-start-date")))), t(a, i);
    }
  }, {
    key: "setLocaleDateFormat",
    value: function setLocaleDateFormat() {
      var _t$find;
      var t = new Intl.DateTimeFormat(this.locale).formatToParts(new Date("12/31/1999")),
        e = (_t$find = t.find(function (l) {
          return l.type === "literal";
        })) === null || _t$find === void 0 ? void 0 : _t$find.value,
        a = {
          day: "dd",
          month: "mm",
          year: "yyyy"
        },
        i = {
          day: "([1-9]|0[1-9]|[12][0-9]|3[01])",
          month: "([1-9]|0[1-9]|1[0-2])",
          year: "\\d{4}"
        },
        n = new Map(),
        o = new Map();
      t.forEach(function (l, u) {
        a[l.type] && (n.set(u, a[l.type]), o.set(u, i[l.type]));
      }), this._dateSeparator = e || "/", this._localizedDateRegex = new RegExp("^".concat(Array.from(o.values()).join(this._dateSeparator), "$")), this.localizedExpectedDateFormat = Array.from(n.values()).join(this._dateSeparator), this._placeholder = this.localizedExpectedDateFormat;
    }
  }, {
    key: "getDateValueFromLocalizedDateString",
    value: function getDateValueFromLocalizedDateString(t) {
      var _this$_localizedDateR, _this$localizedExpect;
      if (!t || t === "") return null;
      if (!((_this$_localizedDateR = this._localizedDateRegex) !== null && _this$_localizedDateR !== void 0 && _this$_localizedDateR.test(t))) return NaN;
      var a = t.split(this._dateSeparator),
        i = ((_this$localizedExpect = this.localizedExpectedDateFormat) === null || _this$localizedExpect === void 0 ? void 0 : _this$localizedExpect.split(this._dateSeparator)) || [],
        n = i.findIndex(function (p) {
          return p.toLowerCase().includes("y");
        }),
        o = i.findIndex(function (p) {
          return p.toLowerCase().includes("m");
        }),
        l = i.findIndex(function (p) {
          return p.toLowerCase().includes("d");
        }),
        u = new Date(parseInt(a[n]), parseInt(a[o]) - 1, parseInt(a[l]));
      return isNaN(u.getTime()) ? NaN : u;
    }
  }, {
    key: "maskDate",
    value: function maskDate(t) {
      var e = t.split(this._dateSeparator).map(function (i) {
        return i.replace(/[^\d]/g, "");
      });
      if (e.length !== 3) {
        this._maskPattern = "";
        return;
      }
      var a = e.findIndex(function (i) {
        return i.length === 4;
      });
      a === -1 ? this._maskPattern = e.map(function (i, n) {
        return n < 2 ? "X".repeat(i.length) : i;
      }).join(this._dateSeparator) : this._maskPattern = e.map(function (i, n) {
        return n === a ? i : "X".repeat(i.length);
      }).join(this._dateSeparator);
    }
  }, {
    key: "toggleVisibility",
    value: function toggleVisibility() {
      var _this$datepickerRef$v2;
      this._datePickerVisible = !this._datePickerVisible, this._datePickerVisible && (this.assignPosition(), (_this$datepickerRef$v2 = this.datepickerRef.value) === null || _this$datepickerRef$v2 === void 0 ? void 0 : _this$datepickerRef$v2.shiftFocusToCalendarGrid());
    }
  }, {
    key: "assignPosition",
    value: function assignPosition() {
      var _this$endInputRef$val,
        _this6 = this;
      var t = this.range ? (_this$endInputRef$val = this.endInputRef.value) === null || _this$endInputRef$val === void 0 ? void 0 : _this$endInputRef$val.controlRef.value : this.controlRef.value;
      !this.datepickerRef || !this.datepickerRef.value || !t || (this._cleanup = _(t, this.datepickerRef.value, /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _yield$I, e, a, i, n;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(!_this6.datepickerRef || !_this6.datepickerRef.value || !t)) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              _context.next = 4;
              return I(t, _this6.datepickerRef.value, {
                placement: "bottom-end"
              });
            case 4:
              _yield$I = _context.sent;
              e = _yield$I.x;
              a = _yield$I.y;
              i = _yield$I.placement;
              n = i.includes("bottom") ? 4 : -4;
              Object.assign(_this6.datepickerRef.value.style, {
                left: "".concat(e, "px"),
                top: "".concat(a + n, "px")
              });
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))));
    }
  }, {
    key: "handleError",
    value: function handleError(t) {
      var _this$minDate, _this$maxDate, _this$minDate2, _this$maxDate2;
      switch (this.dispatchEvent(new y({
        errorReason: b.VALIDATION,
        component: {
          errorReason: t
        }
      })), t) {
        case "invalid-format":
          return this._messageInvalidFormat.replace("{0}", this.localizedExpectedDateFormat);
        case "less-than-min-date":
          return this._messageLessThanMinDate.replace("{0}", ((_this$minDate = this.minDate) === null || _this$minDate === void 0 ? void 0 : _this$minDate.toLocaleDateString(this.locale)) || "");
        case "greater-than-max-date":
          return this._messageGreaterThanMaxDate.replace("{0}", ((_this$maxDate = this.maxDate) === null || _this$maxDate === void 0 ? void 0 : _this$maxDate.toLocaleDateString(this.locale)) || "");
        case "outside-range":
          return this._messageOutsideRange.replace("{0}", ((_this$minDate2 = this.minDate) === null || _this$minDate2 === void 0 ? void 0 : _this$minDate2.toLocaleDateString(this.locale)) || "").replace("{1}", ((_this$maxDate2 = this.maxDate) === null || _this$maxDate2 === void 0 ? void 0 : _this$maxDate2.toLocaleDateString(this.locale)) || "");
        case "invalid-start-date":
          return this._messageInvalidStartDate.replace("{0}", this.startDateLabel || "").replace("{1}", this.endDateLabel || "").replace("{2}", this._endDateInputValue || "");
        case "invalid-end-date":
          return this._messageInvalidEndDate.replace("{0}", this.endDateLabel || "").replace("{1}", this.startDateLabel || "").replace("{2}", this._startDateInputValue || "");
        default:
          return null;
      }
    }
  }]);
}(v);
s.styles = [].concat(_toConsumableArray(L(s, s, "styles")), [x(k)]);
r([h({
  type: Date
})], s.prototype, "value", 2);
r([h({
  type: String,
  attribute: "locale"
})], s.prototype, "locale", 2);
r([h({
  type: Date,
  attribute: "min-date"
})], s.prototype, "minDate", 2);
r([h({
  type: Date,
  attribute: "max-date"
})], s.prototype, "maxDate", 2);
r([h({
  type: Boolean,
  attribute: "sunday-start"
})], s.prototype, "sundayStart", 2);
r([h({
  type: Boolean,
  attribute: "range"
})], s.prototype, "range", 2);
r([h({
  type: Date,
  attribute: "start-date"
})], s.prototype, "startDate", 2);
r([h({
  type: Date,
  attribute: "end-date"
})], s.prototype, "endDate", 2);
r([h({
  type: String,
  attribute: "start-date-label"
})], s.prototype, "startDateLabel", 2);
r([h({
  type: String,
  attribute: "end-date-label"
})], s.prototype, "endDateLabel", 2);
r([h({
  type: Boolean,
  attribute: "mask-input"
})], s.prototype, "maskInput", 2);
r([d()], s.prototype, "dateValue", 2);
r([d()], s.prototype, "_datePickerVisible", 2);
r([d()], s.prototype, "_startDate", 2);
r([d()], s.prototype, "_endDate", 2);
r([d()], s.prototype, "_startDateInputValue", 2);
r([d()], s.prototype, "_endDateInputValue", 2);
r([d()], s.prototype, "_maskPattern", 2);
r([d()], s.prototype, "_dateString", 2);
s = r([g("ngc-input-date"), R()], s);
export { N as DateValidationError, s as NgcInputDate };